import script from "./ProductArticleRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductArticleRow.vue?vue&type=script&setup=true&lang=ts"

import "./ProductArticleRow.vue?vue&type=style&index=0&id=ff88a59c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff88a59c"]])

export default __exports__